import { render } from "./menu_master.vue?vue&type=template&id=2bc4bdb6&scoped=true"
import script from "./menu_master.vue?vue&type=script&lang=js"
export * from "./menu_master.vue?vue&type=script&lang=js"

import "./menu_master.vue?vue&type=style&index=0&id=2bc4bdb6&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc4bdb6"]])

export default __exports__